import { PropsWithChildren, ReactNode } from 'react';

import { getTypeOrNull } from './apollo';
import { AdminV1AccountMode, useAccountSetupQuery } from './graphql';

export const useAccountMode = () => {
  const { data, loading } = useAccountSetupQuery({
    fetchPolicy: 'cache-first',
  });

  const currentAccountData = getTypeOrNull(data?.currentAccount);

  const isTotalConfidence =
    currentAccountData?.mode === AdminV1AccountMode.TotalConfidence;
  const isWarehouseNative =
    currentAccountData?.mode === AdminV1AccountMode.WarehouseNative;
  return {
    loading,
    isTotalConfidence,
    isWarehouseNative,
  };
};

export const TotalConfidence = ({
  children,
  fallback = null,
}: PropsWithChildren<{ fallback?: ReactNode }>) => {
  const { isTotalConfidence } = useAccountMode();
  if (!isTotalConfidence) return fallback;
  return children;
};

export const WarehouseNative = ({
  children,
  fallback = null,
}: PropsWithChildren<{ fallback?: ReactNode }>) => {
  const { isWarehouseNative } = useAccountMode();
  if (!isWarehouseNative) return fallback;
  return children;
};
